import { useState } from "react";

import { Badge, Card, Container } from "react-bootstrap";

import { serviceTypes } from "../constants";

interface NewServiceOrderingContainerProps {
  onContinue: (serviceId: string) => void;
}

const ServiceOrderingBusinessSelector = ({
  onContinue,
}: NewServiceOrderingContainerProps) => {
  const [selectedCard, setSelectedCard] = useState<string | null>(null);
  const handleSelectCard = (id: string) => {
    const service = serviceTypes.find((service) => service.id === id);
    if (service?.enabled) {
      setSelectedCard(id);
    }
  };

  return (
    <div className="bg-container serviceOrdering">
      <Container className="py-4">
        <h3
          className="fw-bold mb-4"
          style={{ fontSize: "24px", color: "var(--color-secondary-dark)" }}
        >
          Choisissez la prestation que vous souhaitez commander
        </h3>
        <div className="d-flex flex-nowrap overflow-auto pb-3">
          {serviceTypes.map((service) => (
            <div
              key={service.id}
              className="flex-grow-1 flex-shrink-0 mt-2"
              style={{
                minWidth: "230px",
                maxWidth: "200px",
                marginRight: "1rem",
              }}
            >
              <Card
                className={`h-100 border ${selectedCard === service.id ? "border-primary" : ""} ${service.enabled ? "cursor-pointer" : "opacity-60"}`}
                onClick={() => handleSelectCard(service.id)}
                style={{
                  transition: "all 0.2s ease-in-out",
                  transform:
                    selectedCard === service.id ? "translateY(-5px)" : "none",
                  boxShadow:
                    selectedCard === service.id
                      ? "0 5px 15px rgba(0,0,0,0.1)"
                      : "none",
                  minHeight: "250px",
                  position: "relative",
                  maxWidth: "190px",
                }}
              >
                {!service.enabled && (
                  <Badge
                    bg="secondary"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      fontSize: "10px",
                    }}
                  >
                    Bientôt sur votre plateforme
                  </Badge>
                )}
                <Card.Body className="d-flex flex-column gap-3 align-items-center">
                    {service.icon && (
                      <service.icon
                        width="60"
                        height="60"
                        fill={
                          service.enabled
                            ? "var(--color-secondary-dark)"
                            : "#A9A9A9"
                        }
                      />
                    )}
                  <h5
                      className="mb-0 fw-bold text-center"
                      style={{ color: "var(--color-secondary-dark)" }}
                    >
                      {service.title}
                    </h5>
                  <p
                    className="text-muted mb-0 text-center"
                    style={{ color: "var(--color-secondary-dark)" }}
                  >
                    {service.subtitle}
                  </p>
                  
                  {service.enabled && (
                    <div 
                      className="radio-button mt-auto"
                      style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        border: '2px solid var(--color-secondary-dark)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '10px'
                      }}
                    >
                      {selectedCard === service.id && (
                        <div 
                          style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--color-secondary-dark)'
                          }}
                        />
                      )}
                    </div>
                  )}
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
        {selectedCard && (
          <div className="d-flex justify-content-start mt-4">
            <button
              className="btn btn-primary px-4"
              onClick={() => onContinue(selectedCard)}
            >
              Continuer
            </button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default ServiceOrderingBusinessSelector;
